import {Component, Input} from '@angular/core';

@Component({
	selector: 'card-placeholder',
	styles: ['.ph-item {background-color: transparent!important; margin-top: 15px!important; margin-bottom: 7px!important;}'],
	template: `
		<div class="ph-item" *ngFor="let index of rows | ngForTimes">
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12 big"></div>
				</div>
			</div>
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12"></div>
					<div class="ph-col-12"></div>
				</div>
			</div>
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12 big"></div>
				</div>
			</div>
		</div>
	`,
})
export class CardPlaceholderComponent {
	@Input() public rows: number = 3;
}
